import { useEffect, useState } from 'react';

/** Navigation ohne Neuladen: pushState + ein Ereignis, auf das `usePath` hört. */
export function navigate(path: string, replace = false): void {
  if (replace) window.history.replaceState(null, '', path);
  else window.history.pushState(null, '', path);
  window.dispatchEvent(new Event('evercourse:navigate'));
}

export function usePath(): string {
  const [path, setPath] = useState(() => window.location.pathname);
  useEffect(() => {
    const update = () => setPath(window.location.pathname);
    window.addEventListener('popstate', update);
    window.addEventListener('evercourse:navigate', update);
    return () => {
      window.removeEventListener('popstate', update);
      window.removeEventListener('evercourse:navigate', update);
    };
  }, []);
  return path;
}

/** Klick auf einen internen Link abfangen – Strg/Cmd-Klick und neue Tabs bleiben dem Browser überlassen. */
export function onLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const href = event.currentTarget.getAttribute('href');
  if (!href || !href.startsWith('/') || event.currentTarget.target === '_blank') return;
  event.preventDefault();
  navigate(href);
}
